import React from 'react';
import { RestaurantMetaInfoSummary } from '../restaurant-meta-info-summary/restaurant-meta-info-summary.tsx';
import { ButtonBubbleTextIcon } from '../../../../../patterns/00-atoms/button/button.tsx';
import { RestaurantDetails_fetchRestaurantRecommendations } from '../../../../../types/graphql-types-generated.ts';
import { Paths } from '../../../../../utils/paths.ts';
import { restaurantImageOrDefault } from '../../../../../utils/restaurant-image-or-default.ts';
import { prgLink } from '../../../../../utils/prg-resolver.ts';
import { UBTracking } from '../../../../../components/tracking/ubtracking.ts';

export type RecommendedRestaurantProps = {
  recommendation: RestaurantDetails_fetchRestaurantRecommendations;
};

export const RecommendedRestaurant: React.FunctionComponent<RecommendedRestaurantProps> = props => {
  const recommendationLink = Paths.rdp(props.recommendation);
  return (
    <div
      onClick={() => {
        UBTracking.state.restaurant = props.recommendation;
        UBTracking.trackEvent.click('closing_element', 'RECOMMENDED_RESTAURANT');
        prgLink(recommendationLink);
      }}
      className="shrink-0 basis-xs cursor-pointer snap-start pl-4"
    >
      <div className="relative">
        <img
          className="h-32 w-full rounded-3xl object-cover"
          src={restaurantImageOrDefault(props.recommendation.profileImageUrl)}
          alt={`Profilbild von ${props.recommendation.name}`}
          loading="lazy"
        />
        {false && (
          <div className="absolute top-0 right-0 mt-2 mr-2">
            <ButtonBubbleTextIcon onClick={console.log} iconName="like" />
          </div>
        )}
      </div>
      <div className="mt-2">
        <span className="text-xl/6 font-extrabold">{props.recommendation.name}</span>
        <RestaurantMetaInfoSummary
          restaurantDetails={props.recommendation}
          cuisineLinking={false}
        />
      </div>
    </div>
  );
};
